import {Component, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {Base} from './pages/base/base';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent extends Base {
  constructor(injector: Injector, private router: Router) {
    super(injector);
    if (localStorage.getItem('UserGoCar') == null || !this.GetUser()) {
      this.router.navigate(['/login']);
      return;
    } else {
    }
  }
}
